export default __webpack_public_path__ + "static/media/room1-MASK-industrial.8647cc65.png";